import { ID } from '@datorama/akita';
import { MapperComponent } from '../mapper.component';

import { MappingField } from '../mapping-field/mapping-field';

export interface MappingTextBoxOptions {
  counterSign: boolean;
  fixedText: boolean;
  height: number;
  left: number;
  scaleX: number;
  top: number;
}

export class MappingTextBox extends MappingField {
  constructor(text: string, options: MappingTextBoxOptions, id: ID, mapperComponent: MapperComponent) {
    super(text, options, id, mapperComponent);
  }

  // Listen to Rect events (private)
  _bindEvents(): void {
    // eslint-disable-next-line no-underscore-dangle
    super._bindEvents();
    this.on('scaling', () => {
      const ctx = this.canvas.contextCache;
      this._render(ctx);
    });
  }
}
